// # #############################################
// # Title : My App
// # Authors : Sameer, Dhruv
// # Date : 15th October 2019
// # Last Modified : Dhruv, August 2019
// # Version : 19.10.03
// # Description : This is the code for the Wrapper for App.js for using the SnackBar
// # ############################################

// Import Required Libraries

import React from "react";
import "../css/App.css";
import App from "../App";
import { SnackbarProvider, withSnackbar } from "notistack";
const Myapp = withSnackbar(App);

// Wrapper for App.js for using the SnackBar

class MyApp extends React.Component {
  render() {
    return (
      <div>
        <SnackbarProvider maxSnack={4} autoHideDuration={2000}>
          <Myapp />
        </SnackbarProvider>
      </div>
    );
  }
}

export default MyApp;
